module.exports = __webpack_public_path__ + "img/blocks.6ca8db7b.png";